import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'
import TimeAgo from 'react-timeago'
import { PobbleAvatar } from 'pobble-components/dist/pobble-avatar'

import WorkCommentFlag from './WorkCommentFlag.js'

import FaPencil from 'react-icons/fa/pencil-square'
import { faFeatherAlt } from '@fortawesome/pro-solid-svg-icons/faFeatherAlt'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import FaHourGlass from 'react-icons/fa/hourglass-o'

@autobind
class WorkComment extends Component {
  render () {
    let comment = this.props.comment
    var country = comment.geolocation && comment.geolocation.country_code ? <div className={`comment__country flag flag-${comment.geolocation.country_code.toLowerCase()}`} data-tooltip={(comment.geolocation.city ? comment.geolocation.city + ', ' : '') + comment.geolocation.country} /> : ''
    var pending = comment.status === 'pending' ? <span data-tooltip='Pending approval' className='comment__pending__icon'><FaHourGlass /></span> : false
    var avatar = <PobbleAvatar avatar={comment.account.avatar} name={comment.account.display_name} style={{fontSize: '40px'}} className='comment__avatar' />
    var newComment = comment.id === this.props.lastComment ? 'js__comment--reveal' : ''

    return (
      <li id={'comment--' + comment.id} className={'comment comment--' + comment.commentor_type.toLowerCase() + ' ' + newComment} key={comment.id}>
        <WorkCommentFlag comment={comment} index={this.props.index} onCommmentFlag={this.props.onCommentFlag} />
        <div className='comment__content'>
          {avatar}
          <div className='comment__item'>
            <header>
              <strong className='comment__author'>
                {
                  comment.account.student_type
                    ? comment.account.first_name && comment.account.first_name.length > 1
                      ? comment.account.first_name
                      : 'A student'
                    : comment.account.display_name || 'A user'
                }
                {comment.commentor_type === 'Author' && <span data-tooltip='Proud author of this work'><FontAwesomeIcon icon={faFeatherAlt} /></span>}</strong>
              {country}
              {pending ? pending : <span className='comment__date'><TimeAgo date={comment.created_at} /></span>}
            </header>
            <p className='comment__body'>{comment.content}</p>
          </div>
        </div>
      </li>
    )
  }
}

WorkComment.propTypes = {
  comment: PropTypes.object,
  lastComment: PropTypes.string,
  onCommentFlag: PropTypes.func,
  index: PropTypes.number
}

export default WorkComment



// WEBPACK FOOTER //
// ./components/work/WorkComment.js